// @flow
export const BOOST_DURATION = 'lastBoostDuration';
export const BOOST_TARGET = 'lastBoostTarget';
export const DASHBOARD_ACTIONS_REMOVED_MODAL = 'dashboard-actions-removed-modal';
export const FIRST_TIME_CUSTOMISATION_MODAL = 'first-time-customisation-modal';
export const HOLIDAY_MODE = 'temperature-warning-accepted';
export const LEAK_SENSOR_PRESENT = 'leak-sensor-present';
export const MANUAL_TARGET_SETTING = 'manualTargetTemperature';
export const MANUAL_TARGET_VALUE = 'manual-target-value';
export const MODAL_DISMISSED = 'modal-dismissed';
export const SCHEDULE_STOP_TOOLTIP = 'schedule-stop-tooltip';
export const SEEN_OFFER = 'seen-offer';
export const SENSE_ANALYTICS_SHARING_MODAL_VIEWED = 'sense-analytics-sharing-modal-viewed';
export const SENSE_SENSORS_FIRST_EVENT_VIEWED = 'sense-sensors-first-event-viewed';
export const SENSE_SENSORS_FIRST_TIME_UNMUTE_DONE = 'sense-sensors-first-time-unmute-done';
export const SENSE_SENSORS_HELP_REQUESTED = 'sense-sensors-help-requested';
export const SENSE_SENSORS_NO_SMOKE_CO = 'sense-sensors-does-not-have-smoke-co';
export const THANK_YOU_ACCEPTED = 'thank-you-popup-accepted';
export const WIDGET_REMOVED_MODAL = 'widget-removed-shown';
export const READY_BY_MODAL_DISMISSED = 'ready-by-modal-dismissed';
export const READY_BY_LEARNT_MORE = 'ready-by-learnt-more';
export const READY_BY_TOOLTIP_DISMISSED = 'ready-by-tooltip-dismissed';



// WEBPACK FOOTER //
// ./src/core/constants/app-settings.js